@if (toastService.toast().visible) {
<div class="toast"
  [class.success]="toastService.toast().type === 'success'"
  [class.error]="toastService.toast().type === 'error'"
  [class.hiding]="toastService.hiding()">
  <app-icon [name]="toastService.toast().type === 'error' ? 'alert' : 'check'" size="sm" />
  <span>{{ toastService.toast().message }}</span>
</div>
}